<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="付款申请" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
								<el-form-item label="付款编码">
									<el-input v-model="searchForm.payment_code" placeholder="请填写付款编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="执行编码">
									<el-input v-model="searchForm.execute_code" placeholder="请填写执行编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="收款方">
									<el-input v-model="searchForm.payee_name" placeholder="模糊搜索收款方名称" clearable></el-input>
								</el-form-item>
								<el-form-item label="收款方类型">
									<el-select v-model="searchForm.receive_type" placeholder="请选择收款方类型" clearable>
										<el-option v-for="item in options.receive_type_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="付款类型">
									<el-select v-model="searchForm.pay_status" placeholder="请选择付款类型" clearable>
										<el-option v-for="item in options.pay_status_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="审批人">
									<el-input v-model="searchForm.check_name" placeholder="可模糊搜索审批人" clearable></el-input>
								</el-form-item>
								<el-form-item label="申请人">
									<el-input v-model="searchForm.u_name" placeholder="可模糊搜索申请人" clearable></el-input>
								</el-form-item>
								<el-form-item label="审批节点">
									<el-select v-model="searchForm.flow_step_id" placeholder="请选择审批类型" clearable>
										<el-option v-for="item in options.check_option" :key="item.id" :label="item.step_name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
								<!-- <el-form-item label="供应商">
															<el-select v-model="searchForm.supplier_id" placeholder="请选择供应商" clearable filterable remote reserve-keyword :remote-method="getSupplierSelect">
																	<el-option
																		v-for="item in options.supplier_id_options"
																		:key="item.value"
																		:label="item.label"
																		:value="item.value">
																	</el-option>
																</el-select>
													</el-form-item> -->
								<!-- <el-form-item label="收款方">
															<el-select v-model="searchForm.payee_name" filterable remote reserve-keyword placeholder="请选择收款方" clearable :remote-method="getUserSelect">
																	<el-option
																		v-for="item in options.applicant_id_options"
																		:key="item.value"
																		:label="item.label"
																		:value="item.value">
																	</el-option>
																</el-select>
													</el-form-item> -->
								<el-form-item label="状态">
									<el-select v-model="searchForm.status" placeholder="请选择付款状态" clearable>
										<el-option v-for="item in options.status_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="付款时间">
									<el-date-picker v-model="searchForm.time_of_payment" type="daterange" format="yyyy-MM-dd"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
								</el-form-item>
								<el-form-item label="申请时间">
									<el-date-picker v-model="searchForm.applicant_time" type="daterange" format="yyyy-MM-dd"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
									<el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0;"
								v-if="$parent.$parent.isAuthAction('admin/resources/resources/pymentrequest') || $parent.$parent.isAuthAction('admin/customers/export/exportpaycollectionexcel')">
								<div>
									<el-button type="primary" size="mini" @click="addInvoiceOpen"
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/pymentrequest')">付款申请</el-button>
								</div>
								<div style="margin-right: 10px;">
									<el-link type="primary" :disabled="isDownloading" icon="el-icon-download" @click="exportData"
										v-if="$parent.$parent.isAuthAction('admin/customers/export/exportpaycollectionexcel')">{{
											isDownloading ? '下载中...' : '下载' }}</el-link>
								</div>
							</div>
							<div class="k-table-con">
								<el-table :data="tableData.data" style="width: 100%" border stripe ref="table" highlight-current-row
									v-loading="loading" @sort-change="sortChange" :height="tableHeight">
									<el-table-column prop="pyment_code" label="付款编码" min-width="180">
										<template slot-scope="scope">
											<el-link type="primary" style="font-size: 12px; text-decoration: underline;" :underline="false"
												@click="detail(scope.row)" target="_blank">{{ scope.row.pyment_code }}</el-link>
										</template>
									</el-table-column>
									<el-table-column prop="pay_status_txt" label="付款类型" min-width="100">
									</el-table-column>
									<el-table-column prop="receive_type_txt" label="收款方类型" min-width="100">
									</el-table-column>
									<el-table-column prop="payee_id_txt" label="收款方" min-width="150">
									</el-table-column>
									<el-table-column prop="uid_txt" label="申请人" width="100">
									</el-table-column>
									<el-table-column label="收款信息" width="300" show-overflow-tooltip>
										<template slot-scope="scope">
											<p
												style="font-weight: bold;height: 20px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
												开户行：{{ scope.row.payee_bank_id_txt }}</p>
											<p style="font-weight: bold;">卡&nbsp;&nbsp; 号：{{ scope.row.payee_bank_num }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="payer_id_txt" label="付款人" width="100">
									</el-table-column>
									<el-table-column prop="time_of_payment" label="实际付款日期" width="150">
									</el-table-column>
									<el-table-column prop="list" label="执行明细" width="100">
										<template slot-scope="scope">
											<el-popover placement="top-start" width="580" trigger="hover">
												<el-table :data="scope.row.execute_list" height="350" style="width: 100%;" border stripe
													highlight-current-row>
													<el-table-column width="80" property="platform_name" label="所属平台"></el-table-column>
													<el-table-column width="100" property="resource_name" label="资源名称"></el-table-column>
													<el-table-column width="300" property="execute_code" label="执行编码"></el-table-column>
													<el-table-column width="100" property="cost" label="付款金额"></el-table-column>
												</el-table>
												<el-link type="primary" slot="reference" style="font-size: 12px;"
													:underline="false">查看详情</el-link>
											</el-popover>
										</template>
									</el-table-column>
									<el-table-column prop="remark" label="审批信息" min-width="200" show-overflow-tooltip>
										<template slot-scope="scope">
											<p
												style="font-weight:bold;height: 20px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
												审批人:&nbsp;&nbsp;&nbsp;&nbsp;{{ scope.row.check_name }}</p>
											<p style="font-weight:bold;">当前节点:&nbsp;{{ scope.row.check_rover }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="remark" label="备注" min-width="200">
									</el-table-column>
									<el-table-column prop="create_time" label="申请时间" width="150">
									</el-table-column>
									<el-table-column fixed="right" prop="status_txt" label="状态" align="center" width="80">
										<template slot-scope="scope">
											<span style="font-weight: bold;">{{ scope.row.status_txt }}</span>
										</template>
									</el-table-column>
									<el-table-column fixed="right" label="操作"
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/returnmessage_paycost') || $parent.$parent.isAuthAction('admin/resources/resources/paymentsubmit') || $parent.$parent.isAuthAction('admin/resources/resources/delpayment')"
										min-width="140">
										<template slot-scope="scope">

											<el-button :disabled="!(scope.row.status == 1)" @click="addConfirmForm(scope.row)" type="text"
												:size="size"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/paymentsubmit')">提交审批</el-button>
											<el-button
												:disabled="!(scope.row.status == 2 && scope.row.order_step && scope.row.order_step <= 2)"
												@click="returnMessage(scope.row)" type="text" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/returnmessage_paycost')">撤回申请</el-button>
											<el-button :disabled="[2, 4].indexOf(scope.row.status) != -1" type="text"
												@click="handleDelete(scope.row)" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/delpayment')">删除申请</el-button>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--申请付款-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" :close-on-press-escape='false'
			:wrapperClosable='false' size="90%">
			<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>申请付款</span>
						<i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="收款方" prop="pay_status">
						<el-radio-group v-model="addForm.pay_status" @input="changePayStatus">
							<el-radio :label="1">供应商</el-radio>
							<el-radio :label="3">平台</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="平台" prop="platform_id" v-if="addForm.pay_status == 3">
						<el-select v-model="addForm.platform_id" placeholder="请选择平台" clearable @change="getChangePlate">
							<el-option v-for="item in options.plateform_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="供应商" prop="supplier_id" v-if="addForm.pay_status == 1 || addForm.platform_id">
						<el-select v-model="addForm.supplier_id" filterable remote placeholder="请选择供应商" clearable
							@change="getChangeSupplier" :remote-method="getSupplierSelect" style="width:100%;">
							<el-option v-for="item in options.supplier_id_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="执行" prop="execute_ids" v-if="addForm.supplier_id">
						<el-select v-model="addForm.execute_ids" multiple filterable remote clearable placeholder="可搜索执行编码"
							style='width: 100%;' @change="addExecuteIds" :remote-method="getSupplier">
							<el-option v-for="item in options.execute_ids_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<div style="padding-top: 8px; color: #F56C6C; font-size:13px;" v-if="execute_tips">{{ execute_tips }}</div>
					</el-form-item>
					<el-row v-for="(item, index) in resource_project_list" :key="index"
						v-if="resource_project_list.length > 0 && addForm.resource_project_list[0].execute_code">
						<el-form-item style="margin-bottom: 0;">
							<el-col :span="10">
								<el-form-item label="执行编码:" label-width="78px">
									<el-input v-model="addForm.resource_project_list[index].execute_code" clearable disabled></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="资源名称:" label-width="78px">
									<el-input v-model="addForm.resource_project_list[index].name" clearable disabled></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="使用金额:" :prop="`resource_project_list[${index}].cost`"
									:rules="[{ required: true, validator: validatorLrId, trigger: 'blur' }]" label-width="88px">
									<el-input @input="cleardikou" v-model="addForm.resource_project_list[index].cost"
										placeholder="请填写使用金额"></el-input>
								</el-form-item>
							</el-col>
						</el-form-item>
					</el-row>
					<el-form-item label="收款方" v-if="addForm.pay_status">
						<el-radio-group v-model="addForm.receive_type" @input="getNewSupplier">
							<el-radio label="OLD">原收款方</el-radio>
							<el-radio label="NEW">其他收款方</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="其他供应商" prop="new_supplier_id" v-if="addForm.receive_type == 'NEW'">
						<el-select style="width:100%;" v-model="addForm.new_supplier_id" filterable remote placeholder="请选择供应商"
							clearable @change="getBankCardNew" :remote-method="getSupplierNew">
							<el-option v-for="item in options.new_supplier_id_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="收款银行" prop="payee_bank_id">
						<el-select v-model="addForm.payee_bank_id" filterable remote placeholder="请搜索收款银行" clearable
							style="width:100%;" @change="addForm.is_deduction = 0">
							<el-option v-for="item in options.bankCard_options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否抵扣" prop="is_deduction" v-if="addForm.payee_bank_id">
						<el-radio-group v-model="addForm.is_deduction" @input="changeRefund">
							<el-radio :label="0">否</el-radio>
							<el-radio :label="1">是</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="退款抵扣" prop="deduction_amount" v-if="addForm.is_deduction == 1">
						<el-select multiple filterable clearable v-model="addForm.refund_ids" placeholder="请选择退款抵扣"
							@change="updateStatus">
							<el-option v-for="item in options.refund_options" :key="item.value" :disabled="item.disabled"
								:label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="付款日期" prop="advance_payment_date">
						<el-date-picker key="advance_payment_date" v-model="addForm.advance_payment_date" type="date"
							format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="申请备注">
						<el-input type="textarea" v-model="addForm.remark" placeholder="请填写申请备注" clearable maxlength="100"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="附件">
						<el-upload action accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xlsx,.xlx,.ppt,.pptx,.eml,.bmp"
							:file-list="addForm.attachment"
							:on-remove="(file) => handleRemoveUpload(file, 'addForm', 'attachment', false)" :auto-upload="false"
							:on-change="(file) => changeRequired(file, 'addForm', 'attachment', false)" :on-preview="viewImg"
							:multiple="true">
							<el-button slot="trigger" size="mini">选取文件</el-button>
							<span style="margin-left: 10px; cursor: pointer;">
								<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf/doc/docx/xlsx/xlx/ppt/pptx/eml/bmp格式"
									placement="bottom-start">
									<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
								</el-tooltip>
							</span>
						</el-upload>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="addInvoice" :size='size' :disabled="paySubmitDisabled">提交</el-button>
					<el-button :size='size' @click="handleButtonClick">取消</el-button>
				</div>
			</el-form>
		</el-drawer>

		<el-dialog :visible.sync="dialogVisibleImg">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		return {
			loading: false,
			isDownloading: false,
			addFormVisiable: false,
			editFormVisiable: false,
			confirmFormVisiable: false,
			paySubmitDisabled: false,
			dialogImageUrl: '',
			dialogVisibleImg: false,
			activeName: 'first',
			size: 'mini',
			pickerOptions: {
				disabledDate (time) {
					// 获取今天的日期
					const today = new Date();
					today.setHours(0, 0, 0, 0); // 设置时间为00:00:00:000
					return time.getTime() < today.getTime(); // 禁用今天之前的日期
				}
			},
			options: {
				check_option: [],
				receive_type_options: [
					{
						value: 'OLD',
						label: '原收款方'
					}, {
						value: 'NEW',
						label: '其他收款方'
					}
				],
				pay_status_options: [
					{
						value: 1,
						label: '供应商付款'
					}, {
						value: 3,
						label: '平台付款'
					}
				],
				status_options: [
					{
						value: 1,
						label: '待提交'
					}, {
						value: 2,
						label: '待审核'
					}, {
						value: 3,
						label: '已驳回'
					}, {
						value: 4,
						label: '正常'
					}
				],
				qr_status_options: [
					{
						value: 3,
						label: '付款'
					}, {
						value: 2,
						label: '驳回'
					}
				],
				invoice_type_options: [
					{
						value: 1,
						label: '普票'
					}, {
						value: 2,
						label: '专票'
					}, {
						value: 3,
						label: '形式发票'
					}
				],
				invoice_status_options: [
					{
						value: 1,
						label: '收票'
					}, {
						value: 2,
						label: '开票'
					}
				],
				supplier_id_options: [],
				applicant_id_options: [],
				bankCard_options: [],
				execute_ids_options: [],//执行下拉列表
				plateform_options: [],//发票录入下拉列表
				refund_options: [],
				new_supplier_id_options: []
			},
			searchForm: {
				payment_code: '',
				check_name: '',
				u_name: '',
				flow_step_id: '',
				receive_type: '',
				pay_status: '',
				execute_code: '',
				payee_name: '',
				status: '',
				time_of_payment: [],
				applicant_time: []
			},
			resetSearch: {
				payment_code: '',
				check_name: '',
				flow_step_id: '',
				receive_type: '',
				pay_status: '',
				execute_code: '',
				payee_name: '',
				status: '',
				time_of_payment: [],
				applicant_time: []
			},
			addForm: {
				pay_status: 1,
				is_deduction: 0,
				platform_id: '',
				supplier_id: '',
				execute_ids: [],
				refund_ids: [],
				receive_type: 'OLD',
				resource_project_list: [{
					execute_id: '',
					cost: '',
					execute_code: ''
				}],
				new_supplier_id: '',
				payee_bank_id: '',
				advance_payment_date: '',
				remark: '',
				attachment: []
			},
			confirmForm: {
				id: '',
				status: '',
				remark: ''
			},
			rules: {
				addForm: {
					'platform_id': [
						{ required: true, message: '请选择平台', trigger: ['change'] }
					],
					'supplier_id': [
						{ required: true, message: '请选择供应商', trigger: ['change'] }
					],
					'new_supplier_id': [
						{ required: true, message: '请选择其他供应商', trigger: ['change'] }
					],
					'refund_ids': [
						{ required: true, message: '请选择退款记录', trigger: ['change'] }
					],
					'execute_ids': [
						{ required: true, message: '请选择执行', trigger: ['change'] }
					],
					'payee_bank_id': [
						{ required: true, message: '请选择付款银行', trigger: ['change'] }
					],
					'advance_payment_date': [
						{ required: true, message: '请选择付款时间', trigger: ['change'] }
					]
				},
				confirmForm: {
					'status': [
						{ required: true, message: '请选择状态', trigger: ['change'] }
					],
					'remark': [
						{
							validator: (rule, value, callback) => {
								if (!value && this.confirmForm.status == 2) {
									callback(new Error('请填写备注信息'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			},
			resource_project_list: [],//发票信息集合
			execute_tips: ''//执行提示
		}
	},
	computed: {
		isSupper: function () {
			return this.info.views.isSupper
		},
		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	watch: {
	},
	mounted: function () {
		// this.handleSearch(this.searchForm);
		this.getPaymentCheckList();
	},
	methods: {
		getPaymentCheckList () {
			this.$api.get('/admin/resources/resources/getpaymentchecklist', { 'set_id': 13 }).then(res => {
				if (res.code === 0) {
					this.options.check_option = res.data;
				}
			})
		},
		addConfirmForm (row) {
			this.loading = true
			this.$api.post('/admin/resources/resources/paymentsubmit', { id: row.id }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (row.id == item.id) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该申请已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 下载excel数据
		exportData () {
			this.isDownloading = true;
			var excelSearch = JSON.parse(JSON.stringify(this.searchForm))
			excelSearch.downloadType = 'paycollection'
			this.$api.get('/admin/customers/export/exportpaycollectionexcel', excelSearch).then(res => {
				if (res.code == 0) {
					this.$alert('异步下载任务【付款申请列表下载】创建成功！请稍后查看下载列表', '下载提示', {
						confirmButtonText: '确定',
					});
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					});
				}
				this.isDownloading = false;
				// 将Blob转换为URL以便创建一个可下载的链接
				// const url = window.URL.createObjectURL(new Blob([res]));
				// const link = document.createElement('a');
				// link.href = url;
				// link.setAttribute('download', '付款申请表.xlsx'); // 设置下载文件名
				// document.body.appendChild(link);
				// link.click(); // 触发点击下载
				// document.body.removeChild(link); // 下载后移除元素
				// window.URL.revokeObjectURL(url); // 释放URL对象
				// this.isDownloading = false
				// this.$alert('您所下载的Excel数据已完毕,请查收！', '下载提示', {
				// 	confirmButtonText: '确定',
				// });
			})
		},
		cleardikou () {
			this.addForm.refund_ids = []
			this.updateStatus([])
		},
		updateStatus (values) {
			if (values.length > 0) {
				// 退款抵扣总和
				let totalCost = this.options.refund_options.filter(record => values.indexOf(record.value) != -1).reduce((sum, record) => sum + Number(record.balance), 0)
				// 付款金额
				let ccost = this.resource_project_list.reduce((sum, record) => sum + Number(record.cost), 0)
				if (totalCost >= ccost) {
					this.options.refund_options.forEach((item, index) => {
						if (values.indexOf(item.value) != -1) {
							this.$set(this.options.refund_options[index], 'disabled', false)
						} else {
							this.$set(this.options.refund_options[index], 'disabled', true)
						}
					})
				} else {
					this.options.refund_options.forEach((item, index) => {
						this.$set(this.options.refund_options[index], 'disabled', false)
					})
				}
			} else {
				this.options.refund_options.forEach((item, index) => {
					this.$set(this.options.refund_options[index], 'disabled', false)
				})
			}

		},
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		changeRefund (val) {
			if (val == 1) {
				this.addForm.refund_ids = []
				var request_data = {}
				if (this.addForm.pay_status == 3) {
					request_data = {
						'pay_status': 2,
						'plarfotm_id': this.addForm.platform_id,
						'bank_id': this.addForm.payee_bank_id
					}
				} else {
					request_data = {
						'pay_status': this.addForm.pay_status,
						'plarfotm_id': this.addForm.receive_type == 'OLD' ? this.addForm.supplier_id : this.addForm.new_supplier_id,
						'bank_id': this.addForm.payee_bank_id
					}
				}
				this.$api.get('/admin/resources/resources/refundpricedwlist', request_data).then(res => {
					if (res.code === 0) {
						this.options.refund_options = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
			}
		},
		initAddForm () {
			this.addForm = {
				pay_status: 1,
				is_deduction: 0,
				platform_id: '',
				supplier_id: '',
				execute_ids: [],
				refund_ids: [],
				resource_project_list: [{
					execute_id: '',
					name: '',
					cost: '',
					execute_code: ''
				}],
				new_supplier_id: '',
				payee_bank_id: '',
				advance_payment_date: '',
				remark: '',
				attachment: []
			};
			this.resource_project_list = [];
			this.execute_tips = '';
			this.options.supplier_id_options = [];
			this.options.execute_ids_options = [];
			this.options.bankCard_options = [];
			this.options.refund_options = [];
		},
		handleButtonClick () {
			this.addFormVisiable = false;
			this.initAddForm()
		},
		getChangePlate (value) {
			this.addForm = Object.assign({}, this.addForm, {
				supplier_id: '',
				execute_ids: [],
				resource_project_list: [{
					execute_id: '',
					name: '',
					cost: '',
					execute_code: ''
				}],
				is_deduction: 0,
				refund_ids: [],
				payee_bank_id: ''
			});
			this.execute_tips = ''
			this.getSupplierSelect()

		},
		getSupplierSelect (query) {
			query = query ? query : '';
			var requet_data = { query: query }
			if (this.addForm.pay_status == 3) {
				requet_data['platform_id'] = this.addForm.platform_id
			}
			this.$api.get('/admin/resources/resources/supldwn', requet_data).then(res => {
				if (res.code === 0) {
					this.options.supplier_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		getUserSelect (query) {
			query = query ? query : '';
			this.$api.post('/admin/users/user/getuserbydepartment', { query: query }).then(res => {
				if (res.code === 0) {
					this.options.applicant_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		returnMessage (row) {
			this.$confirm('此操作将撤销该条申请重新提交, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.post('/admin/resources/resources/returnmessage_paycost', { data_id: row.id, log_id: row.log_id }).then(res => {
					if (res.code === 0) {
						this.$message({
							showClose: true,
							message: '该申请撤销成功！',
							type: 'success'
						});
						this.handleSearch();
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		handleDelete (row) {
			this.$confirm('此操作将永久删除该条申请, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/resources/resources/delpayment', { id: row.id }).then(res => {
					if (res.code === 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.id == row.id) {
								this.$delete(data, index);
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该申请已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		validatorLrId (rule, value, callback) {
			let result = rule.field.match(/\[(.*?)\]/);
			let index = result[1]
			if (!value) {
				callback('请填写使用金额')
			} else {
				if (!isNaN(Number(value)) && value > 0) {
					//实时验证可用票面金额-------发票录入
					this.$api.post('/admin/resources/resources/pricecheck', { execute_id: this.addForm.resource_project_list[index].execute_id, cost: this.addForm.resource_project_list[index].cost }).then(res => {
						if (res.code === 0) {
							callback()
						} else {
							callback('已超出最大可使用金额')
						}
					})

				} else {
					callback('使用金额必须为数字且必须大于0')
				}
			}

		},
		handleSearch: function (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			if (param['payee_name'] && (!param['pay_status'] || !param['receive_type'])) {
				this.$message.error('模糊搜索收款方，【付款类型】和【收款方类型】必填')
				this.loading = false
				return
			}
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/resources/resources/pymentlist', param).then(res => {
				if (res.code === 0) {
					this.tableData = res.data;
					this.$nextTick(() => {
						if (this.$refs.table) {
							this.$refs.table.doLayout();
						}
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},

		getNewSupplier (value) {
			this.addForm.new_supplier_id = ''
			this.addForm.payee_bank_id = ''
			this.addForm.is_deduction = 0
			if (value == 'NEW') {
				this.getSupplierNew()
			} else {
				this.getBankCard()
			}
		},
		getBankCardNew (val) {
			this.addForm.payee_bank_id = ''
			this.$api.get('/admin/resources/resources/supbankdw', { 'relevance': 1, 'sid': val }).then(res => {
				if (res.code === 0) {
					this.options.bankCard_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		getChangeSupplier (query) {
			this.addForm.resource_project_list = [{
				execute_id: '',
				cost: '',
				execute_code: ''
			}]
			this.execute_tips = ''
			this.getSupplier()
			this.getBankCard()
			if (this.addForm.execute_ids.length > 0) {
				this.addForm.execute_ids = []
			}
			if (this.addForm.payee_bank_id) {
				this.addForm.payee_bank_id = '';
			}
		},
		getSupplierNew (query) {
			query = query ? query : '';
			var requet_data = { query: query }
			if (this.addForm.pay_status == 3) {
				requet_data['platform_id'] = this.addForm.platform_id
			}
			this.$api.get('/admin/resources/resources/supldwn', requet_data).then(res => {
				if (res.code === 0) {
					this.options.new_supplier_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		// getSupplierSelect (query) {
		// 	query = query ? query : '';
		// 	this.$api.get('/admin/resources/resources/supldwn', { platform_id: this.addForm.platform_id, query: query }).then(res => {
		// 		if (res.code === 0) {
		// 			this.options.supplier_id_options = res.data;
		// 		} else {
		// 			this.$message.error(res.msg);
		// 		}
		// 	})
		// },
		//获取执行列表
		getSupplier (query) {
			console.log(this.addForm)
			query = query || '';
			this.$api.get('/admin/customers/customer/getexecuteselect', { 'query': query, 'platform_id': this.addForm.platform_id, 'supplier_id': this.addForm.supplier_id, 'pay_status': this.addForm.pay_status, 'status': 'paycollection' }).then(res => {
				if (res.code === 0) {
					this.options.execute_ids_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//获取平台下拉
		getPlateformSelect (query) {
			query = query || '';
			this.$api.get('/admin/resources/resources/platformdwn', { 'query': query }).then(res => {
				if (res.code === 0) {
					this.options.plateform_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//根据所选执行生成对应表格数据
		addExecuteIds () {
			this.cleardikou()
			this.$api.get('/admin/customers/customer/getexecuteselect', { 'public_id': this.addForm.execute_ids, 'status': 'paycollection' }).then(res => {
				if (res.code === 0) {
					const filteredOptions = res.data.filter(opt => this.addForm.execute_ids.includes(opt.value));
					this.resource_project_list = filteredOptions.map(item => ({ execute_id: item.value, name: item.name, execute_code: item.code, invioce_lr_id: "", cost: item.price }));
					this.addForm.resource_project_list = filteredOptions.map(item => ({ execute_id: item.value, name: item.name, execute_code: item.code, invioce_lr_id: "", cost: item.price }));
					//获取申请收票界面可收票金额--------执行
					if (this.addForm.execute_ids.length > 0) {
						this.$api.get('/admin/resources/resources/paymentrequestprice', { execute_ids: this.addForm.execute_ids }).then(res => {
							if (res.code === 0) {
								this.execute_tips = res.msg
							} else {
								this.$message.error(res.msg);
							}
						})
					} else {
						this.execute_tips = ''
					}
				}
			})

		},
		//根据发票录入获取对应
		getCost (index) {
			this.addForm.resource_project_list[index].cost = ''
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate(`resource_project_list[${index}].cost`);
			});
		},
		getBankCard () {
			let id = ''
			if (this.addForm.pay_status == 1) {
				id = this.addForm.supplier_id
			} else {
				id = this.addForm.platform_id
			}
			this.$api.get('/admin/resources/resources/supbankdw', { 'relevance': this.addForm.pay_status, 'sid': id }).then(res => {
				if (res.code === 0) {
					this.options.bankCard_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		changePayStatus (value) {
			this.addForm.supplier_id = ''
			this.addForm.execute_ids = []
			this.addForm.resource_project_list = [{
				execute_id: '',
				cost: '',
				execute_code: ''
			}]
			this.addForm.is_deduction = 0
			this.addForm.refund_ids = []
			this.addForm.payee_bank_id = ''
			this.execute_tips = ''
			if (value == 1) {
				this.getSupplierSelect()//获取供应商下拉
			} else {
				this.getPlateformSelect()//获取平台下拉
			}
		},
		// 申请收票弹窗
		addInvoiceOpen () {
			this.addForm = {
				pay_status: 1,
				supplier_id: '',
				execute_ids: [],
				resource_project_list: [{
					execute_id: '',
					cost: '',
					execute_code: ''
				}],
				receive_type: 'OLD',
				new_supplier_id: '',
				is_deduction: 0,
				refund_ids: [],
				payee_bank_id: '',
				advance_payment_date: '',
				remark: '',
				attachment: []
			}
			this.resource_project_list = []
			this.execute_tips = ''
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
			if (this.addForm.pay_status == 1) {
				this.getSupplierSelect()//获取供应商下拉
			} else {
				this.getPlateformSelect()//获取平台下拉
			}
			this.addFormVisiable = true;
		},
		// 付款申请
		addInvoice () {
			if (this.paySubmitDisabled) return;
			this.paySubmitDisabled = true;
			if (this.addForm.receive_type == 'NEW') {
				this.addForm.supplier_id = this.addForm.new_supplier_id
			}
			const formData = new FormData()
			for (const key in this.addForm) {
				if (key == 'attachment') {
					if (this.addForm[key].length > 0) {
						this.addForm[key].forEach(item => {
							formData.append(key, item)
						})
					} else {
						formData.append(key, '')
					}
				} else if (key == 'resource_project_list' || key == 'execute_ids' || key == 'refund_ids') {
					formData.append(key, JSON.stringify(this.addForm[key]));
				} else {
					formData.append(key, this.addForm[key]);
				}
			}
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					this.$api.post('/admin/resources/resources/pymentrequest', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '申请付款成功！',
								type: 'success'
							});
							this.addFormVisiable = false;
							this.initAddForm()
						} else {
							this.$message.error(res.msg);
						}

						this.paySubmitDisabled = false;

					}).catch(() => {
						this.paySubmitDisabled = false;
					})
				} else {
					this.paySubmitDisabled = false;
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},

		//打开详情页
		detail (row) {
			this.$router.push({
				name: 'payCollectDetail',
				query: { id: row.id, set_id: 13, type: 'detail' }
			});
		},
		//点击查看大图
		viewImg (file) {
			if (!file.path) {
				//还未上传
				let url = URL.createObjectURL(file)
				if (file.name.includes('.jpg') || file.name.includes('.jpeg') || file.name.includes('.png')) {
					this.dialogImageUrl = url;
					this.dialogVisibleImg = true;
				} else {
					window.open(url)
				}
			} else {
				//已上传
				if (file.name.includes('.jpg') || file.name.includes('.jpeg') || file.name.includes('.png')) {
					this.dialogImageUrl = file.path;
					this.dialogVisibleImg = true;
				} else {
					window.open(file.path)
				}
			}
		},
		//上传图片
		changeRequired (file, formobj, field, limitOne = true) {

			if (limitOne) {
				this[formobj][field] = [file.raw]
			} else {
				this[formobj][field].push(file.raw)
			}
		},
		//移除图片
		handleRemoveUpload (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = []
			} else {
				this[formobj][field].forEach(function (item, index) {
					if (item.name == file.name) {
						this.$delete(this[formobj][field], index)
					}
				}.bind(this))
			}

		},
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			// 使用 === 进行严格相等判断
			if (from.path !== '/paycollectdetail') {
				try {
					vm.reset();
				} catch (error) {
				}
			}
		});
	}
}
</script>
<style type="text/css" scoped>
.el-table .el-form-item--mini.el-form-item,
.el-table .el-form-item--small.el-form-item {
	margin-bottom: 0;
}
</style>